import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDUg0J5cwKerWoct27Q6ZdHMIxSakI5KIA'
  }
})
